<template>
  <mds-section border-position="bottom" bold>
    <template #mds-section-title>
      <span id="title-id">{{ filterInfo.title }}</span>
    </template>
    <template #mds-section-actions>
      <mds-button-container right-aligned>
        <mds-button
          v-for="element in filterInfo.actionButtons"
          :key="element.id"
          :variation="element.variation"
          type="button"
          @click="$emit('buttonclick', element.method)"
          >{{ element.text }}</mds-button
        >
      </mds-button-container>
    </template>
    <engagement-layout :leftBar="2" :rightBar="10">
      <template #left-side-bar v-if="filterOptions.length > 0">
        <mds-list-group with-icon size="medium" class="cf-left-advance">
          <mds-list-group-item 
            v-for="d in filterOptions"
            :key="d.id"
            v-bind:active="d.active"
            :text="d.text"
            @click.native="selectedFilter(d)"
          >
          </mds-list-group-item>
        </mds-list-group>
      </template>
      <template #right-side-bar>
        <slot name="dynamic-content"></slot>
      </template>
    </engagement-layout>
  </mds-section>
</template>
<script>
import MdsSection from "@mds/section";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import { EngagementLayout } from "../../component";

export default {
  props: {
    filterInfo: {
      type: Object,
    },
    filterOptions: {
      type: Array,
    },
    leftBar: {
      type: Number,
    },
    rightBar: {
      type: Number,
    },
  },
  components: {
    MdsSection,
    MdsButton,
    MdsButtonContainer,
    EngagementLayout,
    MdsListGroup,
    MdsListGroupItem,
  },

  computed: {},

  async created() {},
  methods: {
    selectedFilter(data) {
      this.$emit("onFilterSelected", data);
    },
  },
};
</script>
<style lang="scss" module></style>
